
























































































import { defineComponent, reactive, toRefs, computed, ref, onMounted, onBeforeUnmount } from '@vue/composition-api';
import * as Common from "../../commons/common"
import http from "../../plugins/http";
import moment from 'moment';
import { BModal } from 'bootstrap-vue';
import AlertArea from "../../components/AlertArea.vue";
import { Lesson, LessonClass } from "../../modules/student/LessonClassList"


export interface Data {
  lessons: Lesson[]
  max_lesson_class_no: number
  modal_title: string
  content: string
  StudentSheetStatusEnum: Readonly<{Answering: number; SelfScoring: number; Scoring: number; Failure: number; Pass: number;}>
  nextButtonDisabled: boolean
  prevButtonDisabled: boolean
  errors: string[]
}

export default defineComponent({
  components: {
    "alert-area": AlertArea,
  },
  setup(props, context){

    const modalContentRef = ref<InstanceType<typeof BModal>>();
    
    /******************************
     * data
     ******************************/

    const state = reactive<Data>({
      lessons: [],
      max_lesson_class_no: 0,
      modal_title: "",
      content: "",
      StudentSheetStatusEnum: Common.StudentSheetStatusEnum,
      nextButtonDisabled: true,
      prevButtonDisabled: true,
      errors: [],
    });

    /******************************
     * モーダル表示
     ******************************/

    const showContentModal = (content: string, title: string) => {
      state.content = content;
      state.modal_title = title;
      modalContentRef.value.show();
    }

    /******************************
     * 講義画面へ遷移
     ******************************/

    const lessonStart = (lesson_class: LessonClass) => {
      if(context.root.$route.fullPath.includes("student_ref")){
        // 教師による生徒なりすまし
        context.root.$router.push(`/teacher_site/student_ref/lesson_class/${lesson_class.id}`).catch(err => {});;
      }else{
        // 生徒本人
        context.root.$router.push(`/${context.root.$store.state.school_url_prefix}/student_site/lesson_class/${lesson_class.id}`).catch(err => {});;
      }      
    }

    /******************************
     * 生徒切り替え
     ******************************/

     const changeStudent = (addIndex: number) => {
      const index = context.root.$store.state.students.findIndex((student: any) => student.student_code === context.root.$store.state.student_code) + addIndex;
      const student: any = context.root.$store.state.students[index];
      context.root.$store.commit("setStudentCode", student.student_code);
      context.root.$store.commit("setStudentName", student.name);
      window.location.reload();
    }

    /******************************
     * mounted
     ******************************/
    
    onMounted(async () => {

      if(!Common.studentSiteLoginCheck(context)){
        return;
      }

      context.root.$store.commit("setIsHeaderDisp", true);
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      
      if(context.root.$store.state.currentUser.role != Common.RoleEnum.Student){
        const index = context.root.$store.state.students.findIndex((student: any) => student.student_code === context.root.$store.state.student_code);
        if(index == -1){
          state.prevButtonDisabled = true;
          state.nextButtonDisabled = true;
        }else{
          if(index > 0){
            state.prevButtonDisabled = false;
          }
          if(index + 1 < context.root.$store.state.students.length){
            state.nextButtonDisabled = false;
          }
        }
      }

      await http.get(`/api/student/lesson_class_list?student_code=${context.root.$store.state.student_code}`).then(response => {
        state.lessons = response.data.lessons.map((x: any) => new Lesson(x));
        state.max_lesson_class_no = response.data.max_lesson_class_no;
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    });

    const formatDate = Common.formatDate;

    return {
      ...toRefs(state),
      modalContentRef,
      formatDate,
      lessonStart,
      showContentModal,
      changeStudent,
    }
  }
});
